<div class="mwp-modal">
  <div class="header">
    <mwp-text-translate text="Update Registered Email" jsonKey="updateRegistedEmail" />
  </div>
  <div class="body">
    @if (registeredEmailForm) {
      <form [formGroup]="registeredEmailForm" class="mb-3">
        <div class="mb-3">
          <mwp-input [form]="registeredEmailForm" labelName="New Registered Email" nameForControl="newEmail" inputType="email" />
        </div>
        <div>
          <mwp-input [form]="registeredEmailForm" labelName="Confirm Registered Email" nameForControl="newEmailConfirm" inputType="email" />
        </div>
      </form>
    }
    <div class="rules-container">
      <div class="rules-inner-container">
        <mat-checkbox [checked]="!registeredEmailForm.get('newEmailConfirm').hasError('notMatching')" [disabled]=true>
          <mwp-text-translate text="Emails Match" jsonKey="emailRule1" />
        </mat-checkbox>
      </div>
    </div>
  </div>
  <div class="footer">
    <button class="mwp-button w-100 mb-3" [disabled]="registeredEmailForm.invalid" (click)="save()">
      <mwp-text-translate text="Submit" jsonKey="submit" />
    </button>
    <button class="mwp-button-secondary w-100" (click)="close()">
      <mwp-text-translate text="CANCEL" jsonKey="cancel" />
    </button>
  </div>
</div>